import { render, staticRenderFns } from "./vipRule.vue?vue&type=template&id=d0bba844&scoped=true&"
import script from "./vipRule.vue?vue&type=script&lang=js&"
export * from "./vipRule.vue?vue&type=script&lang=js&"
import style0 from "./vipRule.vue?vue&type=style&index=0&id=d0bba844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0bba844",
  null
  
)

export default component.exports